function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import Common from "../components/includes/Common";
import moment from "moment";
import { DatePicker, Space, Table, Button, Tabs } from "antd";
import { Container, Row, Col } from "react-bootstrap";
import { Excel } from "antd-table-saveas-excel";
import Moment from "react-moment";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;
var TabPane = Tabs.TabPane;
var SettlementHistory = function SettlementHistory(_ref) {
  var _ref$bill = _ref.bill,
    bill = _ref$bill === void 0 ? null : _ref$bill;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDataLoading = _useState2[0],
    setIsDataLoading = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    settlements = _useState4[0],
    setSettlements = _useState4[1];
  var cols = [{
    title: "Date",
    dataIndex: "date",
    render: function render(date) {
      return /*#__PURE__*/_jsx(Moment, {
        format: "DD/MM/YYYY HH:mm",
        date: date
      });
    },
    key: "date"
  }, {
    title: "Montant",
    dataIndex: "amount",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    },
    key: "amount"
  }, {
    title: "Agent",
    dataIndex: "user",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    },
    key: "user"
  }];
  var handleExport = function handleExport() {
    var excel = new Excel();
    excel.addSheet("sheet").addColumns(cols).addDataSource(settlements, {
      str2Percent: true
    }).saveAs("exp.xlsx");
  };
  useEffect(function () {
    if (bill == null || bill == 'undefined') return;
    bill.bill_settlements.forEach(function (s) {
      setSettlements(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          date: s.created_at,
          amount: s.amount,
          user: s.user.firstname + " " + s.user.lastname
        }]);
      });
    });
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsx(Table, {
            size: "small",
            columns: cols,
            bordered: true,
            loading: isDataLoading,
            dataSource: settlements,
            pagination: true
          })
        })
      })
    })
  });
};
export default SettlementHistory;